export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/account/LoginView.vue'),
    meta: { public: true },
  },
  {
    path: '/custom_login/:token',
    name: 'custom-login',
    component: () => import('@/views/account/CustomLoginView.vue'),
    meta: { public: true },
  },
  {
    path: '/',
    component: () => import('@/layouts/AppLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('@/views/DashboardView.vue'),
      },
      {
        path: 'withdrawal',
        name: 'withdrawal',
        component: () => import('@/views/WithdrawalView.vue'),
      },
      {
        path: 'transferpoint',
        name: 'transferpoint',
        component: () => import('@/views/TransferView.vue'),
      },
      {
        path: 'gozaresh',
        name: 'gozaresh',
        component: () => import('@/views/gozaresh/IndexView.vue'),
      },
      {
        path: 'gozaresh_detail/:code_melli',
        name: 'gozaresh-detail',
        component: () => import('@/views/gozaresh/DetailView.vue'),
      },
      {
        path: 'mamooriat',
        name: 'mamooriat',
        component: () => import('@/views/mamooriat/IndexView.vue'),
      },
      {
        path: 'mamooriat/list',
        name: 'mamooriat-list',
        component: () => import('@/views/mamooriat/ListView.vue'),
      },
      {
        path: 'mamooriat/form',
        name: 'mamooriat-form',
        component: () => import('@/views/mamooriat/FormView.vue'),
      },
      {
        path: 'ezafe_kar',
        name: 'ezafe-kar',
        component: () => import('@/views/ezafe_kar/IndexView.vue'),
      },
      {
        path: 'ezafe_kar/list',
        name: 'ezafe-kar-list',
        component: () => import('@/views/ezafe_kar/ListView.vue'),
      },
      {
        path: 'ezafe_kar/form',
        name: 'ezafe-kar-form',
        component: () => import('@/views/ezafe_kar/FormView.vue'),
      },
      {
        path: 'bime',
        name: 'bime',
        component: () => import('@/views/bime/IndexView.vue'),
      },
      {
        path: 'bime/form',
        name: 'bime-form',
        component: () => import('@/views/bime/SocialFormView.vue'),
      },
      {
        path: 'bime_takmili/form',
        name: 'bime-takmili-form',
        component: () => import('@/views/bime/SupplementaryFormView.vue'),
      },
      {
        path: 'bime/list',
        name: 'bime-list',
        component: () => import('@/views/bime/DetailReportView.vue'),
        meta: { reportKind: 'social' },
      },
      {
        path: 'bime_takmili/list',
        name: 'bime-takmili-list',
        component: () => import('@/views/bime/DetailReportView.vue'),
        meta: { reportKind: 'supplementary' },
      },
      {
        path: 'bime/list_total',
        name: 'bime-list-total',
        component: () => import('@/views/bime/SummaryReportView.vue'),
        meta: { reportKind: 'social' },
      },
      {
        path: 'bime/list_takmili_total',
        name: 'bime-takmili-total',
        component: () => import('@/views/bime/SummaryReportView.vue'),
        meta: { reportKind: 'supplementary' },
      },
      {
        path: 'schedule',
        name: 'schedule',
        component: () => import('@/views/schedule/IndexView.vue'),
      },
      {
        path: 'schedule/form',
        name: 'schedule-form',
        component: () => import('@/views/schedule/FormView.vue'),
      },
      {
        path: 'schedule/form_group',
        name: 'schedule-group-form',
        component: () => import('@/views/schedule/GroupFormView.vue'),
      },
      {
        path: 'schedule/list',
        name: 'schedule-list',
        component: () => import('@/views/schedule/ListView.vue'),
      },
      {
        path: 'users',
        alias: 'user_managmnet',
        name: 'users',
        component: () => import('@/views/manage/UsersView.vue'),
      },
      {
        path: 'users/create',
        name: 'user-create',
        component: () => import('@/views/manage/CreateUserView.vue'),
      },
      {
        path: 'edit_user/:code_melli',
        name: 'edit-user',
        component: () => import('@/views/manage/EditUserView.vue'),
      },
      {
        path: 'need_to_review',
        name: 'need-to-review',
        component: () => import('@/views/manage/NeedToReviewView.vue'),
      },
      {
        path: 'manage_withdrawal',
        name: 'manage-withdrawal',
        component: () => import('@/views/manage/ManageWithdrawalView.vue'),
      },
      {
        path: 'manage_fish_varizi',
        name: 'manage-deposits',
        component: () => import('@/views/manage/DepositSlipsView.vue'),
      },
      {
        path: 'manage_deleted',
        name: 'manage-deleted',
        component: () => import('@/views/manage/DeletedRecordsView.vue'),
      },
      {
        path: 'manage_points',
        name: 'manage-points',
        component: () => import('@/views/manage/PointsListView.vue'),
      },
      {
        path: 'manage_maghta',
        name: 'manage-maghta',
        component: () => import('@/views/manage/ManageMaghtaView.vue'),
      },
      {
        path: 'points/me',
        name: 'points-me',
        component: () => import('@/views/manage/MyPointsView.vue'),
      },
      {
        path: 'request_withdrawal',
        name: 'request-withdrawal',
        component: () => import('@/views/manage/RequestWithdrawalView.vue'),
      },
      {
        path: 'request_withdrawal_time',
        name: 'request-withdrawal-time',
        component: () => import('@/views/manage/WithdrawalTimeView.vue'),
      },
      {
        path: 'report_withdrawal',
        name: 'report-withdrawal',
        component: () => import('@/views/manage/WithdrawalReportView.vue'),
      },
      {
        path: 'manage',
        name: 'manage',
        component: () => import('@/views/manage/ManageView.vue'),
      },
      {
        path: 'refahi',
        name: 'refahi',
        component: () => import('@/views/RefahiView.vue'),
      },
      {
        path: 'refahi/submit_user',
        name: 'refahi-submit-user',
        component: () => import('@/views/refahi/SubmitUserView.vue'),
      },
      {
        path: 'refahi/gozaresh',
        name: 'refahi-report',
        component: () => import('@/views/refahi/ReportView.vue'),
      },
      {
        path: 'refahi/:faza',
        name: 'refahi-facility',
        component: () => import('@/views/refahi/FacilityView.vue'),
      },
      {
        path: 'medical/contact',
        name: 'medical-contact',
        component: () => import('@/views/medical/ContactView.vue'),
      },
      {
        path: 'loan/signup',
        name: 'loan-signup',
        component: () => import('@/views/loan/SignupView.vue'),
      },
      {
        path: 'loan/guarantor',
        name: 'loan-guarantor',
        component: () => import('@/views/loan/GuarantorView.vue'),
      },
      {
        path: 'takmili/signup',
        name: 'insurance-signup',
        component: () => import('@/views/insurance/SignupView.vue'),
      },
      {
        path: 'takmili/costs',
        name: 'insurance-costs',
        component: () => import('@/views/insurance/CostsView.vue'),
      },
      {
        path: 'medical/morajeat',
        name: 'medical-morajeat',
        component: () => import('@/views/medical/VisitsView.vue'),
      },
      {
        path: 'medical/moayenat',
        name: 'medical-moayenat',
        component: () => import('@/views/medical/ExaminationsView.vue'),
      },
      {
        path: 'medical/pishnahad',
        name: 'medical-pishnahad',
        component: () => import('@/views/medical/RecommendationsView.vue'),
      },
      {
        path: 'medical/parvande',
        name: 'medical-parvande',
        component: () => import('@/views/medical/RecordView.vue'),
      },
      {
        path: 'shop',
        name: 'shop',
        component: () => import('@/views/shop/IndexView.vue'),
      },
      {
        path: 'shop/:id',
        name: 'shop-product',
        component: () => import('@/views/shop/ProductView.vue'),
      },
      {
        path: 'shop_create',
        name: 'shop-create',
        component: () => import('@/views/shop/CreateView.vue'),
      },
      {
        path: 'shop_history_order',
        name: 'shop-orders',
        component: () => import('@/views/shop/OrdersView.vue'),
      },
      {
        path: 'shop_history_point',
        name: 'shop-points',
        component: () => import('@/views/shop/PointsHistoryView.vue'),
      },
      {
        path: 'shop_admin',
        name: 'shop-admin',
        component: () => import('@/views/shop/AdminView.vue'),
      },
      {
        path: 'shop_admin/all_kala',
        name: 'shop-admin-products',
        component: () => import('@/views/shop/AdminProductsView.vue'),
      },
      {
        path: 'shop_admin/all_orders',
        name: 'shop-admin-orders',
        component: () => import('@/views/shop/AdminOrdersView.vue'),
      },
      {
        path: 'shop_admin/all_points',
        name: 'shop-admin-points',
        component: () => import('@/views/shop/AdminPointsView.vue'),
      },
      {
        path: ':pathMatch(.*)*',
        name: 'coming-soon',
        component: () => import('@/views/ComingSoonView.vue'),
      },
    ],
  },
]
